import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CommonService } from '../shared/common.service';
import { Section } from './Section';
import { Card } from './card';
import { User } from './User';
import { Notification } from './notification'
import { TosterService } from '../shared/toster.service';
import { AngularFireDatabase } from '@angular/fire/compat/database';
import { Observable, from, map } from 'rxjs';
import { Media } from './Media';
import { TranslateService } from '@ngx-translate/core';
import Swal from 'sweetalert2';
import { RlToastService } from '../shared/rl-toast.service';

@Injectable({
  providedIn: 'root'
})
export class BoardService {
  viewCardSectionName;
  boardType;
  assignmentName;
  isVideoPlaying:boolean=false;
  currentSelectedBoard;
  changeSectionId=0;
  isBlinking: boolean = false;
  textBlink='';
  activeBoardSectionCount=0;
  activeBoardUserName='';
  cardFromGameAnimation='animate__animated animate__flash'
  fireBaseReaction:boolean=false;
  sentences: string[] = [];
  classForScroll="";
  notificationCount;
  scrollClass="boardScroll"
  assignmentId;
  selectedMedia=[];
  currentMediaOwnerName='';
  currentSlectedVideoURl=';'
  curretnSelectedMedia: Media={type:'',name:"",url:"",isPlaying:false};
  boardCreateEdit:boolean=false;
  boardView:boolean=false;
  sectionCreateEdit:boolean=false;
  sectionView:boolean=false;
  cardCreateEdit:boolean=false;
  cardView:boolean=false;
  cardRating:boolean=false;

  imageCount:number=0;
  videoCount:number=0
  audioCount:number=0
  fileCount:number=0
   allNotifications:Notification[]=[];
  currentSelectedSection=new Section();
  currentSelectedSectionCard=new Card();
  sectionCopy;
  sectionData:any=[];
  section: Section[] = [];
  card: Card[] = [];
  activeBoardId:any='';
  activeBoardName:any=''
  activeBoardDesc:any=''
  activeBoardDate:any='';
  activeBoardBagImage='';
  carOwnerList=[];
  users: User[]; 
  cardOwnerListDummy=[]
  // reaction
  likeReactionArray=[];
  loveReactionArray=[];
  hahaReactionArray=[];
  wowReactionArray=[];
  sadReactionArray=[];
  angryReactionArray=[];
  backgroubnndImageArr=[{id:1,name:"demo1"},{id:2,name:"demo2"},{id:3,name:"demo3"},{id:4,name:"demo4"},{id:6,name:"demo6"}]
  forAddCardAnnimation='';
  //comment
  editedCardId=0;
  editedCommentId=0
  addCommmentText;
  editCommmentBack:boolean=false;
  deleteCommmentBack:boolean=false;
  constructor( private http:HttpClient,
             public commonService:CommonService,
             public tosterService:TosterService,
             public translate:TranslateService,
             private rlToastService: RlToastService

  ) { }


  addBoard(boardData:any){
    return this.http.post<any>(`${this.commonService.url}api/board-create`,{boardData});
  }
  updateBoard(updateBoard){
    return this.http.post<any>(`${this.commonService.url}api/board-update`,{updateBoard});
  }
  getAllBoardData(id:any){
      return this.http.get<any>(`${this.commonService.url}api/board-getByUser/${id}`);

     }
     getBoardById(bid:any){
      return this.http.get<any>(`${this.commonService.url}api/board/getById/${bid}`);
     }

  getSectionData(BoardId:any){
     return this.http.get<any>(`${this.commonService.url}api/getSectionData/${BoardId}`);
    }
  createSection(boardData:any){
    return this.http.post<any>(`${this.commonService.url}api/section-create`,{boardData});
  }
  createCard(cardData:any){
    return this.http.post<any>(`${this.commonService.url}api/card-create`,{cardData});
  }
  updateCard(cardUpdate){
    return this.http.post<any>(`${this.commonService.url}api/card-update`,{cardUpdate});
  }
  updateSection(sectionUpdate){
    return this.http.post<any>(`${this.commonService.url}api/section-update`,{sectionUpdate});
  }
  getValidUrlForMediaStorage(){
    return this.http.get<any>(`${this.commonService.url}api/get-sas-token`);
  }

  deleteBoard(boardId,type){
    return this.http.post<any>(`${this.commonService.url}api/board-delete`,{boardId,type });
  }

  deleteSection(sectionId,role,boardId){
    return this.http.post<any>(`${this.commonService.url}api/section-delete`,{sectionId,role,boardId});
  }
  deleteCard(cardId,sectionId,boardId,isDelete,role){
    return this.http.post<any>(`${this.commonService.url}api/card-delete`,{cardId,sectionId,boardId,isDelete,role});
  }

  getSectionUpdateOrAdded(sectionId:any,includeCard){
    return this.http.get<any>(`${this.commonService.url}api/section/getOne/${sectionId}/${includeCard}`);

  }
  getChangedCardByIdOrAddCard(cardId:any,commentFlag){
    return this.http.get<any>(`${this.commonService.url}api/card/getOne/${cardId}/${commentFlag}`);
  }
  getBoardUpdateById(boardId:any){
    return this.http.get<any>(`${this.commonService.url}api/card/getOne/${boardId}`);
  }

  saveCommemt(comment,cardId,commentCount){
    return this.http.post<any>(`${this.commonService.url}api/card-add-comment`,{comment,cardId,commentCount});
  }

  updateCommemt(cardId,comment){
    return this.http.post<any>(`${this.commonService.url}api/card-edit-comment`,{comment,cardId});
  }

  deleteComment(cardId,commentId){
    return this.http.post<any>(`${this.commonService.url}api/card-delete-comment`,{cardId,commentId});
  }



deleteCardFromFireBase(sectionId:any){
  return this.http.get<any>(`${this.commonService.url}api/card/get/${sectionId}`);
}

getInviteUserListForSchool(){
  return this.http.get<any>(`${this.commonService.url}api/get-school-users`);
}

sendInvitationToList(users,type,board_id){
  return this.http.post<any>(`${this.commonService.url}api/invite-users`,{users,type,board_id});
}

getNotification(userId){
  return this.http.get<any>(`${this.commonService.url}api/notification-get/${userId}`);
}

updateNotification(type,board_id,notification_id,permissions){
  return this.http.post<any>(`${this.commonService.url}api/notification-update`,{type,board_id,notification_id,permissions});
}


updateReaction(reactions,card_id){
  return this.http.post<any>(`${this.commonService.url}api/reactions-update` ,{reactions, card_id});

}
removeReaction(card_id){
  return this.http.post<any>(`${this.commonService.url}api/reaction-remove` ,{card_id});

}

getBoardActiveUseList(board_id){
  return this.http.get<any>(`${this.commonService.url}api/board-activeUsers/${board_id}`);

}

saveCardRating(card_id,board_id,section_id,rating){
  return this.http.post<any>(`${this.commonService.url}api/card-rating-update` ,{card_id, board_id,section_id,rating});

}

dragDropCard(cardId,oldSectionId,newSectionId,boardId){
  return this.http.post<any>(`${this.commonService.url}api/swap-card` ,{cardId, oldSectionId,newSectionId,boardId});
}

onReloadGetInfo(){
  return this.http.get<any>(`${this.commonService.url}api/reload-board`);

}

setReactionDisplay(card){
  if (!card || !Array.isArray(card.reactions)) {
    if (card) {
      card.reactions = card.reactions || [];
      card.lastThreeReaction = [];
      card.reactionCount = 0;
    }
    return;
  }
  if(card.reactions.length>3){
    card.lastThreeReaction=[];
card.reactionCount=card.reactions.length-3;
for (let i = card.reactions.length - 1; i >= 0; i--) {
  const reaction = card.reactions[i];
  if (!card.lastThreeReaction.some(r => r.type === reaction.type)) {
  card.lastThreeReaction.push(reaction);
    if (card.lastThreeReaction.length === 3) {
      break; // Stop when we have three unique elements
    }
  }
}
card.lastThreeReaction.reverse();
  }
  else{
    card.lastThreeReaction=[];
    card.reactionCount= card.reactions.length;
    for (let i = card.reactions.length - 1; i >= 0; i--) {
      const reaction = card.reactions[i];
      if (!card.lastThreeReaction.some(r => r.type === reaction.type)) {
      card.lastThreeReaction.push(reaction);
        if (card.lastThreeReaction.length === 3) {
          break; // Stop when we have three unique elements
        }
      }
    }
    card.lastThreeReaction.reverse();

  }
}


  public detectChanges(oldData: any, newData: any): any {
    const changes: any = { changed: false ,changeKey:''};
  
    // Check if both oldData and newData are defined
    if (!oldData && !newData) {
      return changes;
    }
    // Detect value changes
    for (const key in newData) {
      if (newData.hasOwnProperty(key)) {
        if (typeof newData[key] === 'object' && newData[key] !== null) {
          // Deep compare for nested objects
          if (!this.deepEqual(newData[key], oldData ? oldData[key] : undefined)) {
            changes[key] = { old: oldData ? oldData[key] : {undefined}, new: newData[key] };
            changes.changed = false;
            changes.changeKey=key
          }
        } else if (newData[key] !== (oldData ? oldData[key] : undefined)) {
          changes[key] = { old: oldData ? oldData[key] : undefined, new: newData[key] };
          changes.changed = true;
          changes.changeKey=key
        }
      }
    }
    return changes;
  }
  
  
  private deepEqual(obj1: any, obj2: any): boolean {
    if (obj1 === obj2) {
      return true;
    }
  
    if (obj1 == null || obj2 == null || typeof obj1 !== 'object' || typeof obj2 !== 'object') {
      return false;
    }
  
    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);
  
    if (keys1.length !== keys2.length) {
      return false;
    }
  
    for (const key of keys1) {
      if (!keys2.includes(key) || !this.deepEqual(obj1[key], obj2[key])) {
        return false;
      }
    }
  
    return true;
  }


  handleChildAdded(key: string, data: any) {
    if(key.includes('section_')){
      const parts = key.split('_');
      this.getSectionUpdateOrAdded(parts[1],false).subscribe(
        res=>{
          let newSection=this.section.findIndex(section=>section.sectionId===res.sectionId)
          if(newSection===-1){
          this.section.push(res);
          if(this.sectionData.length===0){
            this.section=res.sections;
            this.sectionCopy=[...this.section]
            this.currentSelectedSection=this.section[0];
            this.currentSelectedSection.cards=this.section[0].cards;
            this.sectionCopy=[...this.section]
            }
            this.isBlinking=true;
            this.textBlink=this.translate.instant('gameLabel.Section_added')
            setTimeout(() => {this.changeSectionId=0 ;this.isBlinking=false;this.textBlink=''}, 5000);

            }
        })
  }
  }

  sweetSucees(text) {
    this.rlToastService.success(text);
  }

  // fillSectionFileCount(sectionOrCard ,cardUpdateFlag){
  //   sectionOrCard.forEach((section=>{
  //     if(section.media.length>0){
  //       let mediaTypeCounts = section.media.reduce((acc, currentMedia) => {
  //         if (currentMedia.type==="file") {
  //           acc += 1;
  //         }
  //         return acc;
  //       }, 0);
  //        section.fileCount=mediaTypeCounts
  //     }
  //     else{
  //       section.fileCount=0

  //     }
  //     if(cardUpdateFlag){
  //     section.cards.forEach((card=>{
  //       if(card.media.length>0){
  //         let mediaTypeCounts = card.media.reduce((acc, currentMedia) => {
  //           if (currentMedia.type==="file") {
  //             acc +=1;
  //           }
  //           return acc;
  //         }, 0);
  //         card.fileCount=mediaTypeCounts      
  //        }
  //        else{
  //         card.fileCount=0

  //        }
  //     }))
  //   }
  //   }))
  // }

  fillReactionBag(card){
    if (!card) {
      return;
    }
    if (!Array.isArray(card.reactions)) {
      card.reactions = [];
    }
    if (!Array.isArray(card.cardComment)) {
      card.cardComment = [];
    }
    if(card.cardComment.length===0){
      card.reactionBag="reaction_bag"
    }
    else{
      card.reactionBag=""
    }

    if(card.reactions.length===0){
      card.reactionIconClass="overlap-right-plus_not"
    }
    else{
      card.reactionIconClass="overlap-right-plus"
    }
  }

  fillOnlyOneSctionCount(section){
    if(section.media.length>0){
      let mediaTypeCounts = section.media.reduce((acc, currentMedia) => {
        if (currentMedia.type==="file") {
          acc += 1;
        }
        return acc;
      }, 0);
       section.fileCount=mediaTypeCounts
    }
    else{
      section.fileCount=0

    }
  }


boardInnerPersmissions(allPermissions, board?: any){
  const permissions = this.normalizeBoardPermissions(allPermissions, board);
  this.sectionCreateEdit = permissions.includes('section-create');
  this.sectionView = permissions.includes('section-view');
  this.cardCreateEdit = permissions.includes('card-create');
  this.cardView = permissions.includes('card-view');
  this.cardRating = permissions.includes('card-rating');
}

private normalizeBoardPermissions(allPermissions: any, board?: any): string[] {
  const raw = Array.isArray(allPermissions)
    ? allPermissions
    : (typeof allPermissions === 'string' && allPermissions ? [allPermissions] : []);
  const expanded = new Set<string>();
  const viewActions = ['board-view', 'section-view', 'card-view'];
  const writeActions = [...viewActions, 'card-create', 'card-edit', 'section-edit', 'card-rating'];
  const adminActions = [...writeActions, 'board-create', 'board-edit', 'section-create'];

  raw.forEach((item) => {
    const key = String(item || '').trim().toLowerCase().replace(/_/g, '-');
    if (!key) {
      return;
    }
    if (key === 'admin') {
      adminActions.forEach((action) => expanded.add(action));
    } else if (key === 'write') {
      writeActions.forEach((action) => expanded.add(action));
    } else if (key === 'read') {
      viewActions.forEach((action) => expanded.add(action));
    } else {
      expanded.add(key);
    }
  });

  const user = this.commonService.user || {};
  const userId = String(user.id || user._id || user.userId || this.commonService.userId || '');
  const boardOwnerId = String(board?.user_id || board?.user_info?.id || board?.user_info?._id || '');
  const isOwner = !!userId && !!boardOwnerId && userId === boardOwnerId;
  const sessionPermission = String(user.permissions || '').toLowerCase();
  const isStaff = user.drole === 'Teacher' || user.drole === 'School Admin';

  if (isOwner || board?.edit_flag === true || sessionPermission === 'admin' || (isStaff && isOwner)) {
    adminActions.forEach((action) => expanded.add(action));
  } else if (sessionPermission === 'write') {
    writeActions.forEach((action) => expanded.add(action));
  }

  return Array.from(expanded);
}

    spliteDescription(text){
      let inputString=this.commonService.removeHTMLTags(text);
      this.sentences = inputString.split(/\.\s*/).filter(sentence => sentence.trim().length > 0);
      return this.sentences
    }

    setAddedSectionFirst(){
      const index = this.section.findIndex(sec => sec.sectionId === this.commonService.sectionId);
      if (index !== -1) {
        const [matchedSection] = this.section.splice(index, 1);
       this.section.unshift(matchedSection);
      }
    }
}
